/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempBadgesTagMultiple: {
  name: 'temp-badges-tag-multiple';
  data: string;
} = {
  name: 'temp-badges-tag-multiple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path d="M2 9 1 1l8 1 6 6.001-7 7L2 9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5" cy="5" r="1" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
